module.exports = __webpack_public_path__ + "img/1528400885.833afa45.jpg";